// extracted by mini-css-extract-plugin
export default {"imgContainer":"CardImg_imgContainer__15uyq","imgContainer__img":"CardImg_imgContainer__img__ruO8H"};